import type { TPricesListsResponse } from '~/modules/user/types/pricesLists';
import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';

export default class Cabinet extends AbstractFetch {
  private static readonly RESET_PASSWORD = (userID: number) => `v1/users/${userID}/password`;
  private static readonly PRICES_LISTS = 'v1/prices/lists';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  async resetPassword({ params, userID }: { params: any; userID: number }): Promise<IResponse<any>> {
    return this.fetch(Cabinet.RESET_PASSWORD(userID), {
      method: 'PUT',
      body: params,
    });
  }

  async getPricesLists(): Promise<TPricesListsResponse> {
    return this.fetch(Cabinet.PRICES_LISTS, {
      method: 'GET',
    });
  }
}
